<template>
  <div class="item-panel">
    <div class="panel-container">
      <div class="panel-right">
        <div class="item-panel-title-container">
          <i :class="['far', 'item-panel-icon', icon]"></i>
          <div class="item-panel-title-area">
            <div class="title"><slot name="title" /></div>
            <span class="description text-muted"><slot name="description" /></span>
          </div>
        </div>
      </div>
    </div>
    <div class="item-panel-content">
      <slot name="content" />
    </div>
  </div>
</template>

<style scoped lang="scss">
.item-panel {
  display: inline-block;
  
  border-radius: $layout-minor-border-radius;
  background-clip: border-box;
  /*box-shadow: rgba(65, 69, 88, 0.1) 0px 7px 14px 0px, rgba(0, 0, 0, 0.08) 0px 2px 6px 0px;*/
  border: 1px solid rgba(0, 0, 0, 0.12);
  color: #676a6c;
  background-color: #F9FAFD;
  min-height: 180px;
  min-width: 360px;
  margin-right: 1rem;
  margin-bottom: 1rem;
}
.item-panel-content {
  padding: 0.65rem;
}
.item-panel-title-container {
  border-top-left-radius: $layout-minor-border-radius;
  border-top-right-radius: $layout-minor-border-radius;
  background-color: #ffffff;
  height: 40px;
  line-height: 40px;
  vertical-align: middle;
  padding: 0 0.7rem;
  display: flex;
}
.item-panel-title-area {
  flex: 1;
  display: flex;
  flex-direction: column;
}
.item-panel-title-area .title {
  margin-top: 3px;
  font-size: 0.85rem;
  line-height: 17px;
  height: 17px;
}
.item-panel-title-container .description {
  font-size: 0.8em;
  line-height: 15px;
  height: 15px;
}
.item-panel-icon {
  font-size: 2em;
  width: 2.3rem;
  line-height: 40px;
  vertical-align: middle;
}

.item-panel .panel-container {
  display: flex;
  align-items: stretch;
}

.item-panel .panel-left {
  width: 52px;
}
.item-panel .panel-right {
  flex: 1;  
}

</style>

<script>
export default {
  name: 'ItemPanel',
  props: {
    icon: String,
  }
}
</script>